module.exports = __webpack_public_path__ + "static/img/gptModel41.217973ab.png";